/**
 * Part of starter project.
 *
 * @copyright  Copyright (C) 2021 LYRASOFT.
 * @license    __LICENSE__
 */

import u from '@main';

$(() => {
  const pageBuilderListItem = $('.js-page-builder-list-item');
  const pageBuilderArticleListAjax = u.route('page_builder_article_list_ajax');
  const pageBuilderArticle = $('.js-page-builder-article');
  const excludeId = u.data('exclude_id');

  pageBuilderListItem.on('click', async function () {
    const id = $(this).data('id');
    builderList(id);
  })

  if (pageBuilderListItem.eq(0)) {
    const id = pageBuilderListItem.eq(0).data('id');
    builderList(id);
  }

  async function builderList (id) {
    const res = await u.$http.post(
      pageBuilderArticleListAjax,
      {
        id: id,
        exclude_id: excludeId
      }
    )

    const data = res.data.data.data;
    pageBuilderArticle.html(data);
  }
})
